import { ModuleThread, Thread, spawn } from 'threads';

import { IVector3 } from '@seddi/math-v2';

import { RecolorMethods } from './recolorThread.worker';

//@ts-expect-error worker import
import RecolorThreadWorker from './recolorThread.worker';
import { DomImage } from './domImagesContext';

/**
 * Recolor thread tiny wrapper.
 */
export class RecolorThread {
  /** The thread. */
  private thread: ModuleThread<RecolorMethods>;

  /**
   * Spawn thread.
   */
  public async run(): Promise<void> {
    const thread = await spawn(new RecolorThreadWorker());
    await thread.init();
    this.thread = thread as unknown as ModuleThread<RecolorMethods>;
  }

  /**
   * Loads an image for recoloring.
   * @param image The image.
   * @returns
   */
  public loadImage(image: DomImage): Promise<IVector3[]> {
    return this.thread.loadImage(image);
  }

  /**
   * Recolors a previously loaded image.
   * @param imageId Image id.
   * @param color Target color.
   * @returns The recolored pixels data.
   */
  public recolorImage(imageId: string, color: IVector3): Promise<Uint8Array> {
    return this.thread.recolorImage(imageId, color);
  }

  /**
   * Releases an image.
   * @param imageId Image id.
   */
  public unloadImage(imageId: string): Promise<void> {
    return this.thread.releaseImage(imageId);
  }

  /**
   * Terminate thread.
   */
  public terminate(): Promise<void> {
    return Thread.terminate(this.thread);
  }
}
